import { http } from '../config/config-receituario'

export default {
    listar: async (token) => {
        return http.get('configuracoes', {
            headers: {
                'Authorization': token
            }
        })
    },
    salvar: (token, configuracao) => {
        return http.post('configuracoes', configuracao, {
            headers: {
                'Authorization': token
            }
        })
    },
    deletar: (token, id) => {
        return http.delete(`configuracoes/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    update: (token, configuracao) => {
        return http.put(`configuracoes/${configuracao.id}`, configuracao, {
            headers: {
                'Authorization': token
            }
        })
    },
    sendAlertaReceitaArt: (token, payload) => {
        var configLocal = {}
        var authToken = String(token || '')
        if (authToken && authToken.indexOf('Bearer ') !== 0) {
            authToken = `${authToken}`
        }

        try {
            configLocal = JSON.parse(window.localStorage.getItem('configuracao')) || {}
        } catch (error) {
            configLocal = {}
        }

        var headers = {
            'Authorization': authToken,
            'Content-Type': 'application/json'
        }

        if (configLocal.key) {
            headers.key = configLocal.key
        }

        return http.post('configuracoes/alerta-receita-art', payload, { headers })
            .then((res) => res.data)
    }

}
